import { Group } from '@/components/_common';
import StatusTag from '@/components/_common/StatusTag';
import { useMatrix } from '@/core/domain/enterprise/Matrix/Matrix.hooks';
import {
  VehicleHistoryPortoWorkOrder,
  VehicleHistoryPortoWorkOrderItem,
} from '@/core/domain/workorder/VehiclesHistory/VehiclesHistory.types';
import { workorderComplementColor } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import {
  RegistrationsDefaultCode,
  RegistrationsDefaultCodeLabel,
} from '@/types/Register';
import formatterNumber from '@/utils/number/formatterNumber';
import { getTableScrollX } from '@/utils/table';
import { Card, Descriptions, Typography } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useIntl } from 'react-intl';

interface Props {
  data: VehicleHistoryPortoWorkOrder[];
}

export default function VehicleHistoryWorkOrderListPorto(props: Props) {
  const intl = useIntl();

  const matrixSettings = useMatrix();

  const defaultPartCode = matrixSettings.data?.matrixSettings.defaultPartCode;

  const partCodeColumns = {
    [RegistrationsDefaultCode.barCode]: 'barCode',
    [RegistrationsDefaultCode.companyCode]: 'companyCode',
    [RegistrationsDefaultCode.internalCode]: 'sku',
    [RegistrationsDefaultCode.manufacturerCode]: 'manufacturingCode',
    [RegistrationsDefaultCode.sku]: 'sku',
  };

  const partCodeKey =
    partCodeColumns[defaultPartCode as RegistrationsDefaultCode];

  const columns: ColumnsType<VehicleHistoryPortoWorkOrderItem> = [
    {
      dataIndex: 'itemDescription',
      key: 'itemDescription',
      title: 'Descrição',
      ellipsis: true,
      width: 220,
      render: (value) => (value ? value : '-'),
    },
    {
      dataIndex: partCodeKey,
      key: partCodeKey,
      title:
        RegistrationsDefaultCodeLabel[
          defaultPartCode as RegistrationsDefaultCode
        ],
      ellipsis: true,
      width: 120,
      render: (value) => (value ? value : '-'),
    },
    {
      dataIndex: 'quantity',
      key: 'quantity',
      title: 'Quantidade',
      ellipsis: true,
      width: 120,
      render: (value) => (value ? value : '-'),
    },
    {
      dataIndex: 'employee',
      key: 'employee',
      title: 'Responsável',
      ellipsis: true,
      width: 120,
      render: (value) => (value ? value : '-'),
    },
  ];

  return (
    <>
      {props.data
        .filter((detail) => !!detail.items?.length)
        .map((detail) => (
          <Card style={{ marginBottom: 24 }}>
            <Typography.Title>
              <Descriptions>
                <Descriptions.Item label="Data de Entrada">
                  {detail.entryDate
                    ? moment(detail.entryDate).format('DD/MM/YYYY')
                    : '-'}
                </Descriptions.Item>

                <Descriptions.Item label="Orçamento">
                  <Group gap={12}>
                    <Typography.Text style={{ whiteSpace: 'nowrap' }}>
                      {`${detail.workOrderNumber}/${detail.complementNumber}`}
                    </Typography.Text>

                    <StatusTag
                      color={workorderComplementColor[detail.status]}
                      label={intl.formatMessage({
                        id: `workOrders.${detail?.status}`,
                      })}
                    />
                  </Group>
                </Descriptions.Item>

                <Descriptions.Item label="Cliente">
                  {detail.customer ?? '-'}
                </Descriptions.Item>

                <Descriptions.Item label="KM">
                  {formatterNumber(Number(detail.currentKilometers), {
                    minimumFractionDigits: 0,
                  })}
                </Descriptions.Item>

                <Descriptions.Item label="Empresa">
                  {detail.company.name}
                </Descriptions.Item>
              </Descriptions>
            </Typography.Title>

            <Table
              columns={columns}
              dataSource={detail.items}
              scroll={{ x: getTableScrollX(columns) }}
              pagination={false}
            />
          </Card>
        ))}
    </>
  );
}
